module.exports = ReduxThunk;


//////////////////
// WEBPACK FOOTER
// external "ReduxThunk"
// module id = 35
// module chunks = 0